import React, { useState, useEffect, useRef } from "react";
import clsx from "clsx";

import * as classes from "./Cell.module.css";

export default function Cell(props) {
  // initially displays the value
  // onclick will show a text input
  const {
    val,
    row,
    col,
    height,
    width,
    origVal,
    updateGrid,
    drawRightEdge,
    drawBottomEdge,
    drawLeftEdge,
    drawTopEdge,
    activeCell,
    setHighlightCell,
    highlightCell,
  } = props;
  const [inputVal, setInputVal] = useState(val);
  const [showInput, setShowInput] = useState(false);
  const inputRef = useRef();

  useEffect(() => {
    setInputVal(val);
    setShowInput(false);
  }, [val]);

  const onChangeInput = (e) => {
    const newInput = e.target.value;

    setInputVal(newInput);
    updateGrid(row, col, parseInt(newInput));
    if (newInput.length === 1) {
      setShowInput(false);
    }
  };

  const onClickHandler = (e) => {
    if (!origVal) {
      setInputVal(0);
      updateGrid(row, col, 0);
      setShowInput(true);
      setHighlightCell([row, col]);
      setTimeout(() => {
        if (inputRef.current) inputRef.current.focus();
      }, 10);
    }
  };

  return (
    <div
      className={clsx(classes.Cell, {
        [classes.InputCell]: !origVal,
        [classes.RightEdge]: drawRightEdge,
        [classes.BottomEdge]: drawBottomEdge,
        [classes.LeftEdge]: drawLeftEdge,
        [classes.TopEdge]: drawTopEdge,
        [classes.ActiveCell]: activeCell,
        [classes.HighlightCell]: highlightCell,
      })}
      style={{ height: height, width: width, fontSize: height - 20 }}
      onClick={onClickHandler}
    >
      {(val !== 0) & !showInput ? val : null}

      {showInput ? (
        <input
          className={classes.TextInput}
          style={{
            width: width / 2,
            fontSize: height - 10,
          }}
          value={inputVal !== 0 ? val : null}
          onChange={onChangeInput}
          ref={inputRef}
          maxLength={1}
        ></input>
      ) : null}
    </div>
  );
}
